import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../../../../../../../utils/rel';
import { getSkey } from '../../../../../../../../utils/utils';
import errorBoundary from '@ifeng/errorBoundary';
import { LazyImg } from '@ifeng/ui_pc_lazyLoad';

class Info extends React.PureComponent {
    static propTypes = {
        data: PropTypes.object,
        count: PropTypes.object,
    };

    render() {
        const { data, count } = this.props;

        return (
            <div className={styles.info_box}>
                {data.thumbnailpic && data.thumbnailpic !== '' ? (
                    <div className={styles.pic}>
                        <a href={data.url} target="_blank" rel={rel}>
                            <LazyImg src={data.thumbnailpic} alt={data.title} width="144" height="80" />
                        </a>
                        {data.sourceFrom === 'video' ? <div className={styles.v_logo} /> : ''}
                    </div>
                ) : (
                    ''
                )}
                <div className={styles.text_box}>
                    <p className={styles.text}>
                        <a href={data.url} target="_blank" rel={rel} title={data.title}>
                            {data.title}
                        </a>
                    </p>
                    <p className={styles.time}>
                        {data.source ? <span className={styles.source}>{data.source}</span> : ''}
                        {data.createtime && data.createtime !== '' ? (
                            <span className={styles.date}>{data.newsTime}</span>
                        ) : (
                            ''
                        )}
                    </p>
                    {count ? (
                        <div className={styles.comment}>
                            <a
                                href={`//gentie.ifeng.com/view.html?docName=${data.title}&docUrl=${
                                    data.pcUrl
                                }&skey=${getSkey(data.title, data.pcUrl)}&pcUrl=${data.pcUrl}`}
                                target="_blank"
                                rel={rel}>
                                {count.count}
                            </a>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        );
    }
}

export default errorBoundary(Info);
